import { useTranslations } from 'next-intl'
import { Button } from 'components/ui/Button'
import { Text } from 'components/ui/Text'
import { ContactSupport } from 'components/common/ContactSupport'

export interface FooterOTPProps {
  seconds: number
  resendThreshold: number
  onResend: () => void
}

export const FooterOTP = (props: FooterOTPProps) => {
  const { seconds, resendThreshold, onResend } = props
  const t = useTranslations()

  return seconds >= resendThreshold ? (
    <p className="text-center">
      {t.rich('verify_and_resend_auth_code_support_message', {
        // eslint-disable-next-line react/no-unstable-nested-components
        resend: (children) => (
          <Button as="a" variant="link" isNoSpacing onClick={onResend}>
            {children}
          </Button>
        ),
        // eslint-disable-next-line react/no-unstable-nested-components
        link: (children) => (
          <ContactSupport className="font-medium whitespace-nowrap">
            {children}
          </ContactSupport>
        ),
        email: t('support_email'),
        phone: t('support_tel'),
      })}
    </p>
  ) : (
    <div className="text-center">
      <Text>{t('did_you_get_auth_code')}</Text>
      <Text>
        {t.rich('wait_resend_auth_code', {
          // eslint-disable-next-line react/no-unstable-nested-components
          important: (children) => (
            <span className="font-semibold">{children}</span>
          ),
          countDown: resendThreshold - seconds,
        })}
      </Text>
    </div>
  )
}
